@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

.setup-container {
  height: 100%;
  width: 100%;
  background-color: @setup-page--right--background-color;
  background-image: url('../bg--cubes.svg');
  background-repeat: no-repeat;
  background-position: right 0 top 0;
  background-size: 500px;
  backdrop-filter: blur(4px);
}

.app-logo {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: @space-8 @space-16;
}
